export function lazyRetry<T>(importFn: () => Promise<T>): Promise<T> {
  return importFn().catch((error) => {
    if (error?.message?.includes('ChunkLoadError')) {
      console.warn('ChunkLoadError detected. Reloading...');
      window.location.reload();
    }
    throw error;
  });
}
